import { convertUTCDateToLocalDate, formatDateTimeToString } from "go-core/components/Formatters/FormatDate";
import { OrganizationApplicationAccesses } from "../components/SupportAccessPreview";

export const defaultSupportAccessPermissions = ["SALE", "CONFIGURATION"];

export const mapSupportAccessPermissions = (
	appsAccesses: OrganizationApplicationAccesses[],
	appType: string,
	permissions: string[]
): Array<string> => {
	let perms = appsAccesses.find((f) => f.type === appType);

	if (!perms) {
		return [];
	}

	perms = { ...perms, permissions: Array.from(new Set([...defaultSupportAccessPermissions, ...perms?.permissions])) };

	if (!permissions || permissions.length === 0) {
		return perms.permissions;
	}

	return perms?.permissions?.map((perm) => {
		return permissions.includes(perm) ? perm : "";
	});
};

export const parseSupportAccessDateToLocaleDate = (hours: number) => {
	const milliseconds = new Date().getTime() + 60 * 60 * hours * 1000;
	return formatDateTimeToString(new Date(milliseconds));
};

export const isSupportAccessActive = (dateAny: string | Date | undefined, organizationTimezone?: string) => {
	if (!dateAny) return false;

	const date = dateAny instanceof Date ? dateAny.toISOString() : dateAny;
	const dateUTC = convertUTCDateToLocalDate(date, organizationTimezone);
	const dateNow = new Date();
	return dateUTC ? dateUTC.getTime() > dateNow.getTime() : false;
};
